import { render, staticRenderFns } from "./IncDocFTP.vue?vue&type=template&id=702f9380&"
import script from "./IncDocFTP.vue?vue&type=script&lang=js&"
export * from "./IncDocFTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports